import React, { useCallback, useEffect, useRef, useState } from "react";
import Field from "components/molecules/Field";
import Form from "components/molecules/Form/Form";
import { useForm } from "components/molecules/Form";
import { FiSearch } from "react-icons/fi";
import Button from "components/molecules/Button";
import { FaSquarePlus } from "react-icons/fa6";
import { IoIosArrowDown } from "react-icons/io";
import { DropDown, HeaderContentWrap } from "components/atoms/ContentHeading/ContentHeading.styles";
import AddNewUser from "components/atoms/Customers/ManageUser/AddNewUser/index";
import ModalContainer from "components/molecules/ModalContainer";
import AddNewRole from "components/atoms/Customers/ManageRole/AddNewRole";
import { useSelector } from "react-redux";
import { debounce } from "helpers/common";
import CenterModal from "components/molecules/Modal/CenterModal";
import SelectRangeModal from "components/molecules/SelectRangeModal";
import CalenderIcon from "assets/calander.svg";

import { format } from "date-fns";
import { useAuthContext } from "Context/authContext";
const ContentHeader = ({
  dropdown,
  title,
  para,
  placeholder,
  btnText,
  noButton,
  click,
  UserButton,
  RoleButton,
  setSearchText,
  setSearchQuery,
  searchQuery,
  showDateButton = true,
  filter,
}) => {
  const [form] = useForm();
  const [isDropdown, setIsDropdown] = useState(false);
  const { business } = useSelector((state) => state);
  const [modal, setModal] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState(false);
  const dropdownRef = useRef(null);
  const dropdownIconRef = useRef(null);
  const handleClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      dropdownIconRef.current &&
      !dropdownIconRef.current.contains(event.target)
    ) {
      setIsDropdown(false);
    }
  };
  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setIsDropdown(false);
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const dropdownValue = [
    {
      value: "Show-Comment",
      label: "Show Comment",
    },
    {
      value: "Hide-Comment",
      label: "Hide Comment",
    },
  ];
  const debouncedSetSearchQuery = useCallback(
    debounce((query) => {
      setSearchText((_) => ({ ..._, searchText: query }));
    }, 300),
    []
  );
  const { hasPermission } = useAuthContext("hasPermission");

  return (
      <HeaderContentWrap>
          <div className="left-wrap">
              <div className="heading">
                  <h2>{title}</h2>
                  <p>{para}</p>
              </div>
              <Field
                  type="search"
                  rounded
                  name="search"
                  lg
                  placeholder={placeholder}
                  $bgWhite
                  inputSm
                  noMargin
                  suffix={<FiSearch />}
                  onChange={({target: {value}}) => {
                      debouncedSetSearchQuery(value);
                  }}
              />
              {filter}
          </div>
          <div className="date-wrap">
              {dropdown && (
                  <div className="dropdownWrap" ref={dropdownIconRef} onClick={() => setIsDropdown(prev => !prev)}>
                      <div className="dropdownBtn">
                          <span
                              className="heading"
                              // onClick={() => handleOptionClick(selectedOption)}
                          >
                              Show Comments
                          </span>
                          <IoIosArrowDown style={{color: "white"}} />
                      </div>
                      <DropDown ref={dropdownRef} className={isDropdown ? "active" : ""}>
                          <div className="col">
                              <Form form={form} className="form">
                                  {dropdownValue.map((value, index) => (
                                      <Form.Item
                                          key={index}
                                          name={value.value}
                                          label={value.label}
                                          type="checkbox"
                                          rounded
                                          lg
                                          $bgWhite>
                                          <Field />
                                      </Form.Item>
                                  ))}
                              </Form>
                          </div>
                      </DropDown>
                  </div>
              )}

              {UserButton && hasPermission("manage-user.add-user") && (
                  <ModalContainer
                      width={850}
                      title="Add User"
                      btnComponent={({onClick}) => (
                          <Button onClick={onClick}>
                              <FaSquarePlus />
                              {btnText}
                          </Button>
                      )}
                      content={({onClose}) => <AddNewUser btnText="Add User" onClose={onClose} />}
                  />
              )}
              {RoleButton && hasPermission("manage-roles.add-role") && (
                  <ModalContainer
                      width={850}
                      title="Add New Role"
                      btnComponent={({onClick}) => (
                          <Button onClick={onClick}>
                              <FaSquarePlus />
                              {btnText}
                          </Button>
                      )}
                      content={({onClose}) => (
                          <AddNewRole btnText="Add New Role" onClose={onClose} businessId={business.businessId} />
                      )}
                  />
              )}
               {showDateButton && (
          <Button onClick={() => setModal(true)} width={"100px"}>
            Date
          </Button>
        )}
              <CenterModal open={modal} setOpen={setModal} noBorder title="Filter" width="550">
                  <SelectRangeModal
                      startDate={startDate}
                      endDate={endDate}
                      onClose={() => setModal(false)}
                      onChange={dates => {
                          const [start, end] = dates?.target?.value;
                          setStartDate(start);
                          setEndDate(end);
                      }}
                      onApplyDate={() => {
                          if (startDate && endDate) {
                              setSearchQuery({
                                  ...searchQuery,
                                  startDate: format(new Date(startDate), "yyyy-MM-dd"),
                                  endDate: format(new Date(endDate), "yyyy-MM-dd"),
                              });
                          }
                      }}
                      onClearDate={() => {
                          setStartDate(null);
                          setEndDate(null);
                          if (startDate && endDate) {
                              setSearchQuery({
                                  ...searchQuery,
                                  startDate: "",
                                  endDate: "",
                              });
                          }
                      }}
                  />
              </CenterModal>
          </div>
      </HeaderContentWrap>
  );
};

export default ContentHeader;
